import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Fields } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import MinorIndividual from './MinorIndividual';
import messages from './messages';
import { curryN } from 'ramda';

type Props = {
  fields: Fields,
  meta: {
    error: Object,
  },
  intl: any,
  suffixes: Array<Object>,
};

const MinorRows = ({
  fields,
  meta: { error },
  intl,
  suffixes,
  agingUpMinors = false,
}: Props) => {
  const renderRowHeaders =
    fields.length > 0 ? (
      <Row className="minors-header">
        <div key={1} className="labels-head container-of-inputs">
          <Col xs={6} sm={2}>
            <label>
              <FormattedMessage {...messages.firstName} />
            </label>
          </Col>
          <Col xs={6} sm={2}>
            <label>
              <FormattedMessage {...messages.middleName} />
            </label>
          </Col>
          <Col xs={6} sm={2}>
            <label>
              <FormattedMessage {...messages.lastName} />
            </label>
          </Col>
          <Col xs={6} sm={1}>
            <label>
              <FormattedMessage {...messages.suffix} />
            </label>
          </Col>
          <Col xs={6} sm={2}>
            <label>
              <FormattedMessage {...messages.preferredName} />
            </label>
          </Col>
          <Col xs={6} sm={2}>
            {agingUpMinors ? (
              <label>
                <FormattedMessage {...messages.dateOfBirth} />
              </label>
            ) : (
              <label>
                <FormattedMessage {...messages.age} />
              </label>
            )}
          </Col>
        </div>
        <div key={2} className="container-of-trash">
          <div className="row-remove-btn">
            <label>
              <FormattedMessage {...messages.delete} />
            </label>
          </div>
        </div>
      </Row>
    ) : null;

  const fieldRemoveCurried = curryN(2, fields.remove);
  const renderRows =
    fields.length > 0 ? (
      <div className="minor-rows">
        {fields.map((minor, index) => (
          <MinorIndividual
            intl={intl}
            key={index}
            minor={minor}
            onDelete={fieldRemoveCurried(index)}
            suffixes={suffixes}
            agingUpMinors={agingUpMinors}
          />
        ))}
      </div>
    ) : null;

  return (
    <div>
      {renderRowHeaders}
      {renderRows}
      {fields.length < 9 && (
        <Row>
          <a className="btn-text" onClick={() => fields.push()}>
            <FormattedMessage {...messages.addDetail} />
          </a>
        </Row>
      )}
    </div>
  );
};

export default MinorRows;
